export const brandName = "44黑料区";

export const navLinks = [
  { label: "首页", href: "#top" },
  { label: "实时快讯", href: "#live" },
  { label: "热议事件", href: "#topics" },
  { label: "网友观点", href: "#voices" },
  { label: "话题分区", href: "#channels" },
  { label: "常见问题", href: "#faq" },
];

export const searchSuggestions = [
  "最新热议事件",
  "网友犀利评论",
  "本周黑料热度榜",
  "吃瓜互动专区",
];

export const heroTags = [
  "最新黑料讨论",
  "网友真实评论",
  "犀利观点",
  "吃瓜互动",
  "热点吐槽",
  "事件时间线",
];

export const heroStats = [
  { value: "1,286", label: "今日新增讨论" },
  { value: "84.2万", label: "参与互动人次" },
  { value: "312", label: "在榜热议事件" },
  { value: "4.7万", label: "网友观点条数" },
];

export const tickerItems = [
  { time: "09:41", text: "某热播剧番位之争持续发酵，网友就“谁才是主线”展开长篇辩论" },
  { time: "09:26", text: "联名周边被指实物与宣传差距大，评论区出现大量现场对比图" },
  { time: "09:08", text: "直播间售后争议上热搜，多位买家整理时间线还原沟通过程" },
  { time: "08:52", text: "综艺剪辑争议再起，网友自发剪出“完整版”对照原片" },
  { time: "08:33", text: "某品牌发布会口径前后不一致，公关回应被指避重就轻" },
  { time: "08:15", text: "新版本更新引发玩家不满，社区集中反馈体验问题清单" },
];

export const timelineItems = [
  {
    time: "09:41",
    tag: "热榜第一",
    tone: "hot",
    title: "某热播剧番位之争持续发酵，网友就“谁才是主线”展开长篇辩论",
    summary:
      "从片头排序到宣传物料顺序，网友逐帧对比，讨论焦点逐渐从番位转向剧本结构与角色塑造，评论区出现大量长文分析。",
    comments: 1284,
    heat: "9.8万",
  },
  {
    time: "09:18",
    tag: "现场速报",
    tone: "live",
    title: "联名周边被指实物与宣传差距大，买家整理现场对比图",
    summary:
      "多位买家在同一话题下贴出实物细节，围绕“色差属于合理范围吗”形成两派观点，有人主张退货，也有人认为属于个体差异。",
    comments: 936,
    heat: "6.4万",
  },
  {
    time: "08:56",
    tag: "观点交锋",
    tone: "debate",
    title: "直播间售后争议：沟通记录被完整公开，责任归属引发讨论",
    summary:
      "支持买家的网友认为售后流程不透明，支持商家的网友则强调规则已提前公示。评论区反复出现的词是“先说清楚再卖”。",
    comments: 812,
    heat: "5.1万",
  },
  {
    time: "08:34",
    tag: "深度整理",
    tone: "deep",
    title: "综艺剪辑争议再起，网友自发剪出“完整版”与原片对照",
    summary:
      "围绕“剪辑是否改变人物形象”的话题，出现多条逐段解析帖，讨论从剪辑技巧延伸到真人秀的叙事伦理。",
    comments: 704,
    heat: "4.3万",
  },
  {
    time: "08:12",
    tag: "品牌回应",
    tone: "hot",
    title: "发布会口径前后不一致，公关回应被指避重就轻",
    summary:
      "网友整理出两次公开发言的对比表，讨论集中在“企业该不该为口头承诺负责”，观点明显分化，热度仍在上升。",
    comments: 658,
    heat: "3.9万",
  },
  {
    time: "07:48",
    tag: "社区反馈",
    tone: "deep",
    title: "新版本更新引发体验讨论，社区集中整理问题清单",
    summary:
      "玩家按优先级整理出更新后的体验问题，讨论并未停留在吐槽，更多人在提修改建议与替代方案。",
    comments: 523,
    heat: "3.1万",
  },
];

export const hotTopics = [
  {
    id: "topic-1",
    category: "影视综",
    title: "番位之争背后，到底谁在左右观众的第一印象",
    excerpt:
      "宣传顺序只是导火索，真正被讨论的是剧本分配与角色弧光。梳理网友高频观点，看看大家怎么评。",
    comments: 1284,
    votes: 9642,
    image:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20flat%20lay%20of%20film%20clapperboard%20and%20script%20papers%20on%20warm%20cream%20paper%20background%2C%20soft%20natural%20light%2C%20muted%20vermillion%20accent%2C%20magazine%20still%20life%20photography%2C%20clean%20negative%20space&width=720&height=540&seq=theme-film-2026-a1&orientation=landscape",
  },
  {
    id: "topic-2",
    category: "消费观察",
    title: "联名周边的“宣传图”和“到手实物”，差距到底算不算问题",
    excerpt:
      "一张对比图引发上万条讨论，有人主张维权，有人提醒理性看待生产误差，观点交锋正热。",
    comments: 936,
    votes: 7218,
    image:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20still%20life%20of%20shopping%20parcel%20and%20product%20box%20on%20warm%20beige%20paper%20background%2C%20soft%20daylight%2C%20muted%20amber%20accent%2C%20clean%20magazine%20photography%2C%20generous%20negative%20space&width=720&height=540&seq=theme-retail-2026-b2&orientation=landscape",
  },
  {
    id: "topic-3",
    category: "直播电商",
    title: "售后沟通记录公开之后，评论区出现了两种截然不同的立场",
    excerpt:
      "规则公示与售后体验被放在一起比较，讨论的落点变成了“清晰的规则”与“合理的沟通”哪个更重要。",
    comments: 812,
    votes: 5846,
    image:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20scene%20of%20phone%20on%20tripod%20and%20microphone%20on%20warm%20cream%20desk%2C%20soft%20window%20light%2C%20muted%20jaed%20green%20accent%2C%20clean%20magazine%20composition%2C%20ample%20negative%20space&width=720&height=540&seq=theme-live-2026-c3&orientation=landscape",
  },
  {
    id: "topic-4",
    category: "社区热议",
    title: "新版本更新后，玩家整理的“问题清单”比吐槽更长",
    excerpt:
      "清单里不只有抱怨，还有替代方案与修改建议。社区讨论正在从情绪表达走向具体反馈。",
    comments: 523,
    votes: 4127,
    image:
      "https://readdy.ai/api/search-image?query=minimal%20editorial%20flat%20lay%20of%20checklist%20notes%20and%20pen%20on%20warm%20paper%20background%2C%20soft%20diffused%20light%2C%20muted%20vermillion%20detail%2C%20clean%20magazine%20still%20life%2C%20open%20negative%20space&width=720&height=540&seq=theme-community-2026-d4&orientation=landscape",
  },
];

export const voices = [
  {
    id: "v1",
    name: "理性吃瓜研究所",
    initial: "理",
    role: "高赞观点",
    time: "12分钟前",
    content:
      "先把时间线捋清楚再下结论。宣传顺序可以改，合同和成片才是硬证据。别让情绪替你判断。",
    likes: 2143,
    replies: 316,
  },
  {
    id: "v2",
    name: "只想看完整版",
    initial: "只",
    role: "热评",
    time: "26分钟前",
    content:
      "剪辑真的会影响第一印象。建议把原始素材放出来，让观众自己判断，比吵一百楼都有用。",
    likes: 1876,
    replies: 208,
  },
  {
    id: "v3",
    name: "售后观察员小周",
    initial: "周",
    role: "话题主持",
    time: "41分钟前",
    content:
      "规则提前公示没问题，但公示得不清楚就是问题。买家要的不是情绪安慰，是一句说明白的话。",
    likes: 1542,
    replies: 174,
  },
  {
    id: "v4",
    name: "谨慎发言",
    initial: "慎",
    role: "高赞观点",
    time: "1小时前",
    content:
      "越是热度高的事件，越要等官方和当事方的完整回应。现在贴出来的截图，有多少是完整的呢。",
    likes: 1290,
    replies: 96,
  },
  {
    id: "v5",
    name: "隔壁老帖",
    initial: "隔",
    role: "热评",
    time: "1小时前",
    content: "吃瓜可以，别把推测说成事实。评论区最不缺的就是把“听说”写成“实锤”的人。",
    likes: 1104,
    replies: 132,
  },
  {
    id: "v6",
    name: "建议簿本人",
    initial: "建",
    role: "话题主持",
    time: "2小时前",
    content:
      "比起纯吐槽，我更想看解决方案。问题清单我整理了一份，有补充的可以直接在楼下接龙。",
    likes: 968,
    replies: 88,
  },
];

export const rankingItems = [
  { rank: 1, title: "某热播剧番位之争持续发酵", heat: "9.8万", trend: "up" },
  { rank: 2, title: "联名周边实物与宣传差距讨论", heat: "7.1万", trend: "up" },
  { rank: 3, title: "直播间售后沟通记录公开", heat: "6.4万", trend: "flat" },
  { rank: 4, title: "综艺剪辑争议与完整版对照", heat: "5.1万", trend: "up" },
  { rank: 5, title: "发布会口径前后不一致回应", heat: "4.3万", trend: "down" },
  { rank: 6, title: "新版本更新体验问题清单", heat: "3.9万", trend: "flat" },
  { rank: 7, title: "联名活动的预约规则争议", heat: "3.2万", trend: "up" },
];

export const channels = [
  { name: "影视综", count: 86, icon: "ri-movie-2-line" },
  { name: "消费观察", count: 64, icon: "ri-shopping-bag-3-line" },
  { name: "直播电商", count: 52, icon: "ri-live-line" },
  { name: "社区热议", count: 47, icon: "ri-chat-smile-2-line" },
  { name: "品牌公关", count: 39, icon: "ri-megaphone-line" },
  { name: "数码体验", count: 33, icon: "ri-smartphone-line" },
  { name: "生活方式", count: 28, icon: "ri-leaf-line" },
  { name: "职场话题", count: 21, icon: "ri-briefcase-line" },
];

export const trustPoints = [
  {
    icon: "ri-time-line",
    title: "时间线优先",
    text: "每个热点都尽量按发生顺序整理，先看过程，再下判断。",
  },
  {
    icon: "ri-scales-3-line",
    title: "多立场并置",
    text: "同一事件下的不同观点并列呈现，不做单向引导。",
  },
  {
    icon: "ri-shield-check-line",
    title: "社区共识守则",
    text: "鼓励事实描述，反对人身攻击与未经证实的指控。",
  },
];

export const faqItems = [
  {
    q: "44黑料区的热点内容是怎么排出来的？",
    a: "以讨论量、互动增速与停留时长为主要参考，按时间维度持续更新。热度高的内容会被提升到实时快讯与热榜中，方便你先看当前最集中的讨论。",
  },
  {
    q: "在这里发表的评论会被展示吗？",
    a: "本页为静态展示页面，评论、点赞等按钮用于演示交互效果，不会真实提交内容。正式上线后，互动内容会经过社区守则审核再展示。",
  },
  {
    q: "怎样才算是一条合格的网友观点？",
    a: "描述事实、给出依据、说明立场，是社区最鼓励的三件事。反对把猜测写成结论，也反对针对个人的攻击性表达。",
  },
  {
    q: "热点事件后续会更新吗？",
    a: "会。事件有新的公开回应或信息时，时间线会补充新的节点，原有的讨论也会保留，方便你对照前后变化。",
  },
  {
    q: "我可以只围观不发言吗？",
    a: "当然可以。浏览、点赞、收藏都不需要你留下观点。想参与讨论时，再整理好想法加入就好。",
  },
];

export const footerColumns = [
  {
    title: "浏览",
    links: ["实时快讯", "热议事件", "网友观点", "话题分区"],
  },
  {
    title: "参与",
    links: ["社区守则", "观点规范", "举报通道", "话题申请"],
  },
  {
    title: "关于",
    links: ["关于我们", "内容声明", "联系方式", "常见问题"],
  },
];

export const ctaPoints = [
  "每天中午与深夜各一次热点速递",
  "只发整理过的讨论，不转发未证实的说法",
  "可随时取消，不打扰你的日常浏览",
];